import { Checkbox } from "@/components/ui/checkbox";
import Term from "./Term";
import { Label } from "@/components/ui/label";

interface OnListToggleProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const ID = "program-news-on-list-only";

const OnListToggle = ({ checked, onChange }: OnListToggleProps) => {
  return (
    <div className="flex items-center gap-2">
      <Checkbox id={ID} checked={checked} onCheckedChange={value => onChange(value === true)} />
      <Label htmlFor={ID} className="text-sm font-normal cursor-pointer">
        <Term term="on_list">On a list only</Term>
      </Label>
    </div>
  );
};

export default OnListToggle;
